import { useState, useEffect } from "react";
import * as bp from "~styles/breakpoints.module.scss";

const useBreakpoints = () => {
  const breakpointWidths = { ...bp };
  const breakpointKeys = Object.keys(breakpointWidths);
  const initialBreakpoints = {};

  for (let i = 0; i < breakpointKeys.length; i++) {
    initialBreakpoints[breakpointKeys[i]] = true;
  }

  const [breakpoints, setBreakpoints] = useState(initialBreakpoints);

  const updateBreakpoints = () => {
    const parseBpStringToInt = (bpStringWithPx) =>
      parseInt(bpStringWithPx.replace(`px`, ``));

    const updatedBreakpoints = {};
    for (let i = 0; i < breakpointKeys.length; i++) {
      updatedBreakpoints[breakpointKeys[i]] =
        window.innerWidth >=
        parseBpStringToInt(breakpointWidths[breakpointKeys[i]]);
    }

    if (JSON.stringify(breakpoints) !== JSON.stringify(updateBreakpoints)) {
      setBreakpoints(updatedBreakpoints);
    }
  };

  useEffect(() => {
    updateBreakpoints();

    window.addEventListener(`resize`, updateBreakpoints);
    return () => window.removeEventListener(`resize`, updateBreakpoints);
  }, []);

  return breakpoints;
};

export default useBreakpoints;
